/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Timeline_Track_No_Events_VisibleInputs */



/**
* | output |
* | --- |
* | "No events visible in current view or no events defined" |
*
* @param {Timeline_Track_No_Events_VisibleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const timeline_track_no_events_visible = /** @type {((inputs?: Timeline_Track_No_Events_VisibleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Timeline_Track_No_Events_VisibleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Aucun evenement visible dans la vue actuelle ou aucun evenement defini")
	if (locale === "de") return /** @type {LocalizedString} */ ("In der aktuellen Ansicht sind keine Ereignisse sichtbar oder es sind keine Ereignisse definiert.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Nessun evento visibile nella vista corrente o nessun evento definito")
	if (locale === "ru") return /** @type {LocalizedString} */ ("В текущем представлении события не отображаются или события не определены")
	if (locale === "es") return /** @type {LocalizedString} */ ("No hay eventos visibles en la vista actual o no hay eventos definidos")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("当前视图中未显示任何事件，或未定义任何事件。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("現在のビューにイベントが表示されていないか、イベントが定義されていません")
	if (locale === "hi") return /** @type {LocalizedString} */ ("वर्तमान दृश्य में कोई घटनाएँ दिखाई नहीं दे रही हैं या कोई घटनाएँ परिभाषित नहीं हैं")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Nenhum evento visível na visualização atual ou nenhum evento definido.")
	return /** @type {LocalizedString} */ ("No events visible in current view or no events defined")
});